// Shared auth utilities — read from storage, check roles
import { STORAGE_KEYS } from '../../config/env';

export const getAuthData = () => {
  try {
    const item = localStorage.getItem(STORAGE_KEYS.auth) || sessionStorage.getItem(STORAGE_KEYS.auth);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
};

export const getCurrentUserRole = () => {
  const auth = getAuthData();

  return (
    auth?.user?.role ||
    auth?.role ||
    auth?.profile?.role ||
    auth?.currentUser?.role ||
    ''
  );
};

export const getCurrentUser = () => {
  const auth = getAuthData();
  return {
    id: auth?.user?.id || auth?.user_id || auth?.id || null,
    role: auth?.user?.role || auth?.role || '',
  };
};

export const isAdminUser = () => {
  return String(getCurrentUserRole()).toLowerCase() === 'admin';
};
